import { deleteData, getData, postData, putData } from "./APIServiceInterface";

export const getLayerRuleService = (layerId) => {
  return getData(`maintenance/layerRule/get?layerId=${layerId}`);
};

// export const getLayerService = (drawingId) => {
//   return getData(`maintenance/layer/get?drawingId=${drawingId}`);
// };

export const getLayerService = (drawingId ) => {
  return getData(`maintenance/GetDrawingLayerInfo/get?drawingId=${drawingId }`);
}

export const deleteLayer = async (payload) => {
  return await deleteData("maintenance/layerDependency/delete", payload);
};

export const createNewLayerRule = async(payload) => {
  return await putData('maintenance/layerRule/create', payload);
}
